/**
 * The shared threat picture, held once and read by the map and the planner.
 *
 * Separate from the mission store on purpose: threats are not a property of any
 * one plan, they are a property of the airspace, and both the live COP and a
 * draft route are checked against the same list.
 */

import { create } from 'zustand';

import { listThreats, saveThreats, type Threat } from '@/api/threats';

interface ThreatState {
  threats: Threat[];
  setThreats: (threats: Threat[]) => void;
  loadThreats: () => Promise<void>;
  /** Replace the whole list and persist it — bulk, never a partial patch. */
  commit: (threats: Threat[]) => Promise<void>;
}

export const useThreatStore = create<ThreatState>((set, get) => ({
  threats: [],
  setThreats: (threats) => set({ threats }),
  loadThreats: async () => {
    const result = await listThreats();
    if (result.ok) set({ threats: result.data.threats });
  },
  commit: async (threats) => {
    set({ threats });
    await saveThreats(threats);
    void get();
  },
}));
